import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class BzObjectRelation<T extends EMode = EMode.entity> {
  /** Alias: setSignatureFromTempFile */
  setSignatureFromTempFile?: string;

  __typename?: string;
}

const fields: FieldDefinitions<BzObjectRelation> = {
  setSignatureFromTempFile: {
    alias: 'setSignatureFromTempFile',
  },
  __typename: {
    alias: '__typename',
  },
};

export const bzObjectRelationEntityDefinition: EntitiyDefinition<BzObjectRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'BzObjectRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
